module.exports = __webpack_public_path__ + "static/media/vehicle.8e46c5c9.svg";